// extracted by css-extract-rspack-plugin
export default {"IconButton_0":"SubmitButton-module__IconButton_0__LCM4Q5L"};